import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertaTipo5Component } from './alerta-tipo5.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ AlertaTipo5Component ],
  exports: [ AlertaTipo5Component ]
})
export class AlertaTipo5Module { }
